// Pour activer les popovers de bootstrap
window.popovers = function(selector = '[data-toggle="popover"]', options = {trigger: 'focus'}) {
  $(selector).popover(options);
}

$(document).on("turbolinks:load", function(){
  popovers();
});
